import { render, staticRenderFns } from "./MetadataList.vue?vue&type=template&id=17fc518f&"
import script from "./MetadataList.vue?vue&type=script&lang=js&"
export * from "./MetadataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports